export default "__VITE_ASSET__Cyv5gzab__"